import React from 'react';
import './close-drawer.scss';
import {ReactComponent as CloseDrawerButton} from '../../assets/icons/menu/close-button.svg';

export const CloseDrawer = ({drawerOpen, setDrawerOpen}:any) => {
    const handleCloseDrawer = () => {
        if (drawerOpen) setDrawerOpen(false);
    };

    return (
        <CloseDrawerButton className="close-drawer-button" onClick={handleCloseDrawer} />
    );
};
